/**
 * The bot chat renders inside a Drawer (desktop) / fixed panel (mobile) at a
 * very high z-index (9998–9999). antd overlays — Select dropdowns, Tooltips,
 * Popovers, Dropdowns — otherwise portal to `document.body` at their default
 * z-index (~1050), so they render *behind* the widget and become invisible and
 * unclickable (e.g. the ticket quantity / delivery-method dropdowns show no
 * options).
 *
 * Routing each popup into its trigger's parent keeps it inside the widget's own
 * stacking context (so it paints above the panel) and makes it scroll together
 * with the chat transcript. Pass this to `<ConfigProvider getPopupContainer=…>`
 * so every antd popup in the widget subtree inherits it.
 *
 * NOTE: antd `Modal` does not use `getPopupContainer` (it portals via
 * `getContainer` at z-index 1000); those are lifted above the panel with an
 * explicit `zIndex` at each usage instead.
 */
export const botPopupContainer = (triggerNode?: HTMLElement): HTMLElement =>
  triggerNode?.parentElement ?? document.body;
